<template>
  <button :type="type" class="icon-button" :class="`icon-button--${themeColor}`" @click="onClick">
    <div class="icon-button__icon">
      <slot name="icon"></slot>
      <font-awesome-icon :icon="`${iconBaseClass} ${icon}`" :size="iconSize" />
    </div>
    <span class="icon-button__label">{{ label }}<slot></slot></span>
  </button>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    label?: string;
    icon?: string;
    iconBaseClass?: string;
    type?: "button" | "submit" | "reset";
    iconSize?: string;
    themeColor?: string;
  }>(),
  {
    label: "",
    icon: "",
    iconBaseClass: "fa-solid",
    type: "button",
    iconSize: "xl",
    themeColor: "secondary",
  }
);

const emit = defineEmits<{
  (e: "click"): void;
}>();

const onClick = (event: MouseEvent) => {
  emit("click");
};
</script>

<style lang="scss" scoped>
.icon-button {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 8px 16px;
  background: white;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 12px;
  color: #333;

  &:disabled {
    opacity: 0.8;
    cursor: unset;
  }

  &:hover:not(:disabled) {
    background: #2c5aa0;
    border-color: #2c5aa0;
    color: white;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(44, 90, 160, 0.2);

    .icon-button__icon {
      color: white;
    }
  }

  &--primary {
    background: #2c5aa0;
    border-color: #2c5aa0;
    color: white;

    .icon-button__icon {
      color: white;
    }

    &:hover:not(:disabled) {
      background: #244880;
    }
  }

  &__icon {
    color: #2c5aa0;
    transition: color 0.3s ease;
  }

  &__label {
    font-size: 12px;
  }
}
</style>
